import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import styles from "../commanstyles.module.css";
import { IoMdLock } from "react-icons/io";
import { IoDocumentTextOutline } from "react-icons/io5";
import { FiDownload } from "react-icons/fi";

function Shareholdingmorethanfivetable({ data, isSubScribe }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [isTableOneOpen, setIsTableOneOpen] = useState(true);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const rowsPerPage = 10;

  // Set default value to the most recent financial year in the data
  useEffect(() => {
    if (data && data.length > 0) {
      const sortedYears = data
        .map((item) => item.financialYear)
        .sort((a, b) => new Date(b) - new Date(a));
      setSelectedFinancialYear(sortedYears[0]);
    }
  }, [data]);

  const toggleTableOne = () => {
    if (!isSubScribe) {
      alert("Please unlock to see the data.");
      return;
    }
    setIsTableOneOpen((prev) => !prev);
  };

  const filteredData = data.filter(
    (item) => item.financialYear === selectedFinancialYear
  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  return (
    <div className={styles.table_subcontainer}>
      {isSubScribe && (
        <div className={styles.highlet_header_content1}>
          <p className={styles.minuse_icon} onClick={toggleTableOne}>
            {isTableOneOpen ? (
              <FaMinusSquare size={22} />
            ) : (
              <FaPlusSquare size={22} />
            )}
          </p>
          <h3 className={styles.highlet_text}>
            SHAREHOLDING MORE THAN 5%
            {filteredData.length > 0 && selectedFinancialYear && ` FOR FY ENDING ON - 31 Mar, ${selectedFinancialYear}`}
          </h3>

          {/* Financial Year Filter */}
          <div className={styles.yearSelectContainer}>
            {filteredData.length > 0 && (
              <select
                value={selectedFinancialYear}
                onChange={(e) => setSelectedFinancialYear(e.target.value)}
              >
                {data
                  .map((item) => new Date(item.financialYear).getFullYear()) // Extract only the year
                  .filter((value, index, self) => self.indexOf(value) === index) // Remove duplicates
                  .sort((a, b) => b - a)
                  .map((year) => {
                    return (
                      <option key={year} value={year}>
                        {parseInt(year) - 1} - {year}
                      </option>
                    );
                  })}
              </select>
            )}
          </div>
        </div>
      )}

      {!isSubScribe && (
        <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}

      {isSubScribe && isTableOneOpen && (
        <>
          {/* Reference Documents Section */}
          <div className={styles.referencedoc_main}>
            <b>Reference Documents</b>
            {filteredData.map((item) => (
              <div key={item.Id} className={styles.referencedoc_container}>
                {item.refDoc ? (
                  <>
                    <div>
                      {item.refDoc?.MaiinFileName && (
                        <a
                          href={item.refDoc?.fileurl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.referencedoc_mainfilename}
                          style={{ color: "#083A7F", display: "inline-block", marginBottom: "10px", cursor: "pointer" }}
                        >
                          {item.refDoc?.MaiinFileName}
                        </a>
                      )}
                      <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                        {item.refDoc?.Attachments && item.refDoc?.Attachments.length > 0 ? (
                          item.refDoc?.Attachments.map((attachment, index) => (
                            <li
                              key={index}
                              className={styles.referencedoc_Attachments}
                              style={{ marginBottom: "8px", cursor: "pointer" }}
                            >
                              <IoDocumentTextOutline
                                size={16}
                                style={{
                                  marginRight: "8px",
                                  color: "#2961EF",
                                  flexShrink: 0,
                                  cursor: "pointer",
                                }}
                              />
                              <a
                                href={attachment.fileurl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: "#2961EF",
                                  cursor: "pointer",
                                }}
                              >
                                {attachment.Name}
                              </a>
                              <button
                                onClick={() => {
                                  const link = document.createElement("a");
                                  link.href = attachment.fileurl;
                                  link.download = attachment.Name;
                                  link.click();
                                }}
                                title="Download"
                                style={{
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                  color: "#F5B301",
                                  marginLeft: "10px",
                                  textDecoration: "underline",
                                }}
                              >
                                <FiDownload />
                              </button>
                            </li>
                          ))
                        ) : (
                          <span>No attachments available.</span>
                        )}
                      </ul>
                    </div>
                  </>
                ) : (
                  <span>No documents available for selected year</span>
                )}
              </div>
            ))}
          </div>
          <table className={styles.commantable}>
            <thead>
              <tr className={styles.tableHeaderRow}>
                <th className={styles.tableHeader}>SNo.</th>
                <th className={styles.tableHeader}>Name</th>
                <th className={styles.tableHeader}>DIN</th>
                <th className={styles.tableHeader}>
                  Total No. of Equity Shares
                </th>
                <th className={styles.tableHeader}>(%)Equity Shareholding </th>
                <th className={styles.tableHeader}>
                  Total No. of Preference Shares
                </th>
                <th className={styles.tableHeader}>
                  (%)Preference Shareholding{" "}
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((row, index) => (
                  <tr key={row.Id} className={styles.tableRow}>
                    <td className={styles.tableCell}>
                      {indexOfFirstRow + index + 1}.
                    </td>
                    <td className={styles.tableCell}>{row.name || "-"}</td>
                    <td className={styles.tableCell}>{row.DIN || "-"}</td>
                    <td className={styles.tableCell}>
                      {row.shareholding_percentage || "0"}
                    </td>
                    <td className={styles.tableCell}>
                      {row.shareholding_percentage}
                    </td>
                    <td className={styles.tableCell}>
                      {row.total_no_of_preference_shares}
                    </td>
                    <td className={styles.tableCell}>
                      {row.preference_shareholding}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className={styles.noDataRow}>
                  <td colSpan="7" className={styles.noDataRow} style={{ textAlign: "center" }}>
                    No Share Holding data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>


        </>
      )}
    </div>
  );
}

export default Shareholdingmorethanfivetable;
